module.exports = __webpack_public_path__ + "img/37.69fbf27f.jpg";